import { VisualTypes } from 'reporting-snowflake/relational/schema/visual-records';
import { createColumnAlias } from 'reporting-snowflake/relational/utils/column-utils';
import { getReportVisualType } from 'reporting-snowflake/relational/utils/report-utils';
import { findEncodedChannelWithColumnAlias } from 'reporting-snowflake/relational/utils/visual-utils';
import { getColumnValue, getIsStagedColumn } from './column-utils';
import { getNewColumnFromPropertyValue } from './property-utils';
import { getPreferredChannelForMeasure, getPreferredChannelForDimension } from './visual-utils';
export const getBreakdownChannel = relationalReport => {
  const visualType = getReportVisualType(relationalReport);
  if (visualType === VisualTypes.COMBO) {
    return 'breakdown';
  }
  return 'color';
};
export const getAddMetricColumnAndChannel = (metricAliases, relationalReport, allAvailableColumns) => {
  const defaultPropertyAlias = metricAliases.first();
  const maybeChannel = findEncodedChannelWithColumnAlias(relationalReport.visual, defaultPropertyAlias);
  if (maybeChannel) {
    const column = relationalReport.columns.get(defaultPropertyAlias).set('alias', createColumnAlias());
    return {
      column,
      channel: maybeChannel.name
    };
  } else {
    const channel = getPreferredChannelForMeasure(relationalReport.visual);
    const column = allAvailableColumns.first();
    return {
      column,
      channel
    };
  }
};
export const buildAddColumnParams = (value, allAvailableColumns, relationalReport, tableAndPropertyMeta, allDatasetFields, channel) => {
  const foundColumn = allAvailableColumns.find(column => getColumnValue(column) === value);
  const newColumn = getNewColumnFromPropertyValue(getColumnValue(foundColumn), tableAndPropertyMeta, [], [], relationalReport, allDatasetFields);
  const finalChannel = channel || getPreferredChannelForDimension(relationalReport.visual);
  return {
    column: newColumn.set('alias', createColumnAlias()),
    channel: finalChannel
  };
};
export const buildRemoveColumnParams = (currentColumn, relationalReport, allStagedColumns, tableAndPropertyMeta, allDatasetFields) => {
  const columnAlias = currentColumn.alias;
  const originalColumn = relationalReport.columns.get(columnAlias);
  const originalColumnValue = getColumnValue(originalColumn);
  const isStagedColumn = getIsStagedColumn(originalColumnValue, allStagedColumns);
  if (!isStagedColumn) {
    const newColumnForStagedColumns = getNewColumnFromPropertyValue(originalColumnValue, tableAndPropertyMeta, [], [], relationalReport, allDatasetFields);
    return {
      action: 'moveToStaged',
      params: {
        originalColumn,
        newColumnForStagedColumns
      }
    };
  } else {
    return {
      action: 'removeFromReport',
      params: {
        column: originalColumn
      }
    };
  }
};
export const buildUpdateColumnParams = (value, currentColumn, relationalReport, allAvailableColumns, allStagedColumns, tableAndPropertyMeta, allDatasetFields) => {
  const columnAlias = currentColumn.alias;
  const originalColumn = relationalReport.columns.get(columnAlias);
  const originalColumnValue = getColumnValue(originalColumn);
  const isStagedColumn = getIsStagedColumn(originalColumnValue, allStagedColumns);
  const foundColumn = allAvailableColumns.find(column => getColumnValue(column) === value);
  const newColumn = getNewColumnFromPropertyValue(getColumnValue(foundColumn), tableAndPropertyMeta, [], [], relationalReport, allDatasetFields);
  if (!isStagedColumn) {
    return {
      action: 'updateWithStaged',
      params: {
        alias: columnAlias,
        newColumn: newColumn.set('alias', columnAlias),
        originalColumn,
        isReplace: true,
        expressionField: undefined
      }
    };
  } else {
    return {
      action: 'updateWithoutStaged',
      params: {
        alias: columnAlias,
        column: newColumn.set('alias', columnAlias),
        isReplace: true,
        expressionField: undefined
      }
    };
  }
};